import { faArrowDown } from '@fortawesome/pro-solid-svg-icons';
import { Action, Alert, Card, Icon } from 'corso-admin-ui';
import {
  automationsDisplayName,
  Pegasus,
  returnOrWarrantyHookDescription,
} from 'corso-types';
import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useAutomationsForHook } from '~/features/settings/hooks/useAutomations';
import { returnOrWarrantyHookIcon } from './automationsContent';
import AutomationRuleList from './AutomationsList';

function AutomationListByReturnOrWarrantyHook({
  hook,
}: {
  hook: Pegasus.ReturnOrWarrantyHook;
}) {
  const automations = useAutomationsForHook(hook);

  return (
    <Card id={hook}>
      <AutomationRuleList
        automations={automations}
        icon={returnOrWarrantyHookIcon[hook]}
        label={automationsDisplayName.hook[hook]}
        description={returnOrWarrantyHookDescription[hook]}
        draggable
      />
    </Card>
  );
}

function HookEvents({ hook }: { hook: Pegasus.Hook }) {
  const location = useLocation();
  const eventsHookSupports = Pegasus.eventsForHook[hook].filter(
    (eventType) => !Pegasus.hiddenEvents.includes(eventType),
  );

  return eventsHookSupports.length ? (
    <div className="flex flex-col items-center gap-2 pt-3">
      <p className="mb-2 text-sm font-medium text-neutral-500">
        {/* // ? maybe replace with a divider that looks like: ----- + ----- */}
        Add a new automation for this step:
      </p>

      <div className="flex flex-wrap justify-center gap-2">
        {eventsHookSupports.map((eventType) => (
          <Action
            key={eventType}
            to={{
              pathname: 'create',
              search: new URLSearchParams({
                eventType,
                hook,
                returnTo: location.pathname,
              }).toString(),
            }}
            accessibilityLabel={`Add ${automationsDisplayName.eventType[eventType]} rule`}
          >
            {automationsDisplayName.eventType[eventType]}
          </Action>
        ))}
      </div>
    </div>
  ) : null;
}

export default function AutomationsAsFlow() {
  return (
    <div className="space-y-4">
      <Alert
        elevated
        variant="tip"
        heading="Automations follow the listed order. Lower numbers run first. Drag and drop to update the priority."
      />
      {Pegasus.returnOrWarrantyHook.map((hook) => (
        <Fragment key={hook}>
          <AutomationListByReturnOrWarrantyHook hook={hook} />
          <HookEvents hook={hook} />
          <div className="flex justify-center text-neutral-500 last:hidden">
            <Icon icon={faArrowDown} className="size-6" />
          </div>
        </Fragment>
      ))}
    </div>
  );
}
